import clsx from 'clsx';
import { memo, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';

import { productsAndServicesConfig } from './utils';
import ProductsCategory from './components/productsCategory';
import { ClientStatusContext } from '../../../../common/client-status';

const useStyles = makeStyles((theme: Theme) => ({
  gridContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    overflowY: 'auto',
    rowGap: '16px',
    columnGap: '16px',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr'
    }
  },
  headSection: {
    gridColumn: '1 / 3',
    [theme.breakpoints.down('md')]: {
      gridColumn: '1'
    }
  },
  productsSection: {
    gridColumn: '1 / 3',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      gridColumn: '1'
    }
  }
}));

const ProductsAndServices = () => {
  const classes = useStyles();
  const { checkIfUserHasApiPrivilege } = useContext(ClientStatusContext);

  return (
    <Box className={classes.gridContainer} data-testid="products-and-services-page">
      <Box className={clsx(classes.headSection)}>
        <Box ml={1} mb={3}>
          <Typography variant="h2">Products and services</Typography>
        </Box>
        <Box>
          <AlertBoxMsg severity="info">
            <span>
              Currently to enable or disable products or services you need to contact with Qrios support by{' '}
              <a href="mailto:support@qrios.com">support@qrios.com</a>
            </span>
          </AlertBoxMsg>
        </Box>
      </Box>
      {productsAndServicesConfig(checkIfUserHasApiPrivilege).map(({ title, products }, index) => (
        <ProductsCategory key={index} className={classes.productsSection} title={title} products={products} />
      ))}
    </Box>
  );
};

export default memo(ProductsAndServices);
